export default {
  KEY_IS_LOGIN:'login',
  KEY_USER_INFO:'userInfo',
  KEY_SELECT_COUNTRY:'selectCountry',
  KEY_LANG_LIST:'langList',
  KEY_USER_TOKEN:'userToken',
  KEY_WEBUSER_ID:'webUserId',
  EVENT_LANG_CHANGE:'langChangeEvent',
  EVENT_COUNTRY_CHANGE:'countryChangeEvent',
  EVENT_CART_NUM_CHANGE:'cartNumChangeEvent'
}



// WEBPACK FOOTER //
// ./src/utils/consts.js